<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="120">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="项目名称"
                    prop="projId">
                    <Select v-model="info.projId"
                        transfer
                        placeholder
                        :disabled="loading">
                        <Option v-for="(item, index) in projList"
                            :value="item.id"
                            :key="index">{{item.projName}}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="订单号"
                    prop="orderNumbers">
                    <Input v-model="info.orderNumbers"
                        placeholder
                        :maxlength="50"
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="状态"
                    prop="orderStatus">
                    <Select v-model="info.orderStatus"
                        transfer
                        placeholder
                        :disabled="loading">
                        <Option v-for="(item, index) in orderStatusList"
                            :value="item.id"
                            :key="index">{{item.text}}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="支付时间"
                    prop="payTime">
                    <date-picker :disabled="loading"
                        style="width: 100%"
                        v-model="info.payTime"
                        transfer
                        type="datetime"></date-picker>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="秒杀价"
                    prop="price">
                    <input-number v-model="info.price"
                        placeholder
                        :disabled="loading">
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="房号"
                    prop="houseName">
                    <Input v-model="info.houseName"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="认购时间"
                    prop="buyTime">
                    <date-picker :disabled="loading"
                        style="width: 100%"
                        v-model="info.buyTime"
                        transfer
                        type="datetime"></date-picker>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="认购金额"
                    prop="amount">
                    <input-number v-model="info.amount"
                        placeholder
                        :disabled="loading">
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="购房人姓名"
                    prop="buyerName">
                    <Input v-model="info.buyerName"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="购房人手机号"
                    prop="buyerTel">
                    <Input v-model="info.buyerTel"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="购房人身份证号"
                    prop="buyerCard">
                    <Input v-model="info.buyerCard"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="置业顾问手机号码"
                    prop="adviserTel">
                    <Input v-model="info.adviserTel"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="参与人微信头像"
                    prop="avatarUrl">
                    <base-img type="url"
                        :src="info.avatarUrl"
                        height="32"
                        width="32"></base-img>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="参与人微信昵称"
                    prop="nickName">
                    <Input v-model="info.nickName"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="电子认购协议"
                    prop="agreement">
                    <span class="agreement"
                        @click="downloadAgreement">点击下载pdf</span>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="备注"
                    prop="cancelReason">
                    <Input :disabled="loading"
                        v-model="info.cancelReason"
                        placeholder
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { projList } from '@/api/proj-manager'
import { orderAdd, orderUpdate, orderView } from '@/api/order-info'
import { fileDownload } from '@/api/sys-oss'
import Dict from '@/utils/dict'
import BaseImg from '@/components/base-img'
import dayjs from 'dayjs'
export default {
    name: 'OrderForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    components: { BaseImg },
    inject: {
        $modal: {
            default: null
        }
    },
    data() {
        return {
            info: {
                id: this.id,
                houseName: '', //房号
                projId: '', //项目编号
                orderNumbers: '', //订单号
                orderStatus: '', //订单状态
                payTime: '', //支付时间
                price: '', //秒杀价
                buyTime: '', //认购时间
                amount: '', //认购金额
                buyerName: '', //购房人姓名
                buyerTel: '', //购房人手机号
                buyerCard: '', //购房人身份证号
                adviserTel: '', //置业顾问手机号
                agreement: '', //电子协议
                cancelReason: '', //取消订单原因
                nickName: '', //参与人微信昵称
                avatarUrl: '', //参与人微信头像
                projName: '', //项目名称,
                ver: '' //版本号
            },
            projList: [],
            dict: {
                orderStatus: Dict.NULL
            },
            loading: false
        }
    },

    computed: {
        ruleValidate() {
            return {

            }
        },

        orderStatusList() {
            return this.dict.orderStatus.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return orderView(this.id)
            } else {
                return Promise.resolve()
            }
        },

        downloadAgreement() {
            fileDownload(this.info.agreement, '电子认购协议.pdf')
        },
    },

    mounted() {
        var $info = this.$refs.info
        this.loading = true
        // 预加载
        let body = {
            page: 1,
            pageSize: 999
        }
        this.$modal.beforeEnter(next => {
            Promise.all([
                    Dict.get(['order_status']),
                    projList(body),
                    this.fetch()
                ])
                .then(args => {
                    var [dictGroup, proj, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name] || Dict.NULL
                    })
                    this.projList = proj.data.page.list
                    if (view) {
                        var viewData = view.data
                        viewData.buyTime = viewData.buyTime ?
                            dayjs(viewData.buyTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                            ) :
                            ''
                        viewData.payTime = viewData.payTime ?
                            dayjs(viewData.payTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                            ) :
                            ''
                        viewData.agreement = viewData.agreement ?
                            viewData.agreement :
                            ''
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    formData.buyTime = formData.buyTime ?
                        dayjs(formData.buyTime).format('YYYY-MM-DD HH:mm:ss') :
                        ''
                    formData.payTime = formData.payTime ?
                        dayjs(formData.payTime).format('YYYY-MM-DD HH:mm:ss') :
                        ''
                    if (this.id) {
                        return orderUpdate(formData)
                    } else {
                        return orderAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => (options.closeModal = false))
                .finally(() => next())
        })
    }
}
</script>
<style lang="less"
    scoped>
.agreement {
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        color: @primary-color;
    }
}
</style>